<template>
  <div class="grid grid-cols-2 rows-3 lg:grid lg:grid-cols-4 gap-4 mx-auto mt-3">
        <div v-for="item in milestone_objects" :key="item" class="col-sm transition-all duration-900 ease-in-out" :class="[item.span_full && isMobile ? 'col-span-2' : 'col-span-1']">
            <button class="flex justify-center mx-auto h-full w-full bg-racing-stars-dirty-yellow rounded-md border transition duration-100 ease-in-out border-racing-stars-yellow hover:bg-[#544f2b] active:bg-[#635d30] animate-flow">
                <div class=" flex flex-col mx-3 my-6">
                    
                    <div class="flex flex-col mx-auto justify-center">
                        <p class="text-white mx-auto px-2 font-semibold h-12 w-full text-center">{{item.title}}</p>
                        <div v-if="!rewardCounts[item.tag]" class="flex flex-col mx-auto justify-center">

                            <span v-if="item.type == 'streak'" class="relative">
                                <img class="h-36 m-auto" :src="asset('images/milestones/flames.png')" />
                                <p class="text-4xl text-center text-white absolute top-[2.3em] w-full font-bold">{{milestone[item.tag]}}</p>
                            </span>

                            <span v-else-if="item.type == 'counter'" class="relative">
                                <img class="w-36 h-36 mx-auto" :src="asset('images/milestones/winning-trophy.svg')"/>
                                <p class="text-4xl text-center text-gray-800 absolute top-6 w-full font-bold">{{milestone[item.tag]}}</p>
                            </span>

                            <p class="text-center font-semibold text-sm text-gray-300">{{item.description}}</p>
                        </div>

                        <div v-else @click="openReward(item.tag)" class="flex flex-col mx-auto justify-center">
                            <!-- <img src="images/milestones/gift.svg" class="animate-rock absolute"/>
                            <p v-if="true" class="text-center font-semibold text-xl text-white"> Claim Reward!</p> -->

                            <span class="w-24 h-32 mx-auto relative">
                                <img src="images/milestones/gift.svg" class="animate-rock absolute w-40 h-32"/>
                            </span>

                            <span class="w-full rounded-full mx-auto ">Milestone Met</span>

                            <span v-if="rewardCounts[item.tag] == 1"  class="w-full rounded-full mx-auto font-bold text-2xl">Reward Available</span>
                            <span v-else class="w-full rounded-full mx-auto font-bold text-2xl">{{rewardCounts[item.tag]}} Rewards Available</span>
                        </div>

                        <tw-modal :show="showReward" @close="showReward = false" title="New Reward Earned!" :padding="true">
                            <p class = "text-3xl mx-auto text-center">You Just Won</p>

                                <div class="rounded-3xl bg-gray-700 p-2 mx-8" v-if="currentReward.value.booster_tag">
                                    <div class="flex relative justify-center w-40 mx-auto">
                                        <div class="absolute inline-block top-24 sm:top-28 right-8 bottom-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-120 scale-y-70 py-0.5 px-1.5 text-2xl sm:text-2xl leading-none text-center whitespace-nowrap align-baseline font-bold bg-[#45413c] text-white rounded-full z-10 text-centre">×{{currentReward.value.amount}}</div>
                                        <img class="w-fit sm:h-36 h-28 mx-auto" :src="asset(reward_cards[currentReward.value.booster_tag].img)" />
                                    </div>
                                    <p class="text-2xl font-bold text-center mt-4">{{reward_cards[currentReward.value.booster_tag].prize}}</p>
                                </div>

                                <div class="rounded-3xl bg-gray-700 p-2 mx-8" v-else-if="currentReward.value.type">
                                    <div class="flex relative justify-center w-40 mx-auto">
                                        <div class="absolute inline-block top-24 sm:top-28 right-8 bottom-auto translate-x-2/4 -translate-y-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-120 scale-y-70 py-0.5 px-1.5 text-2xl sm:text-2xl leading-none text-center whitespace-nowrap align-baseline font-bold bg-[#45413c] text-white rounded-full z-10 text-centre">×{{currentReward.value.amount}}</div>
                                        <img class="w-fit sm:h-36 h-28 mx-auto" :src="asset(reward_cards[currentReward.value.type].img)" />
                                    </div>
                                    <p class="text-2xl font-bold text-center mt-4">{{reward_cards[currentReward.value.type].prize}}</p>
                                </div>

                            <p v-if="currentReward.value.additional_tokens" class="text-center w-fit">AND</p>

                            <span v-if="currentReward.value.additional_tokens" class="flex flex-col-2 justify-center rounded-full bg-gray-700 p-2 mx-[5em] xs:mx-[6em]">
                                <img class="w-8 h-8 my-auto mr-2" :src="asset('images/coin-and-tokens/token-optimised.svg')" />
                                <p class="font-semibold text-2xl w-fit text-center"> × {{ currentReward.value.additional_tokens }}</p>
                            </span>

                            <button :disabled="currentReward.value.id == null" @click="claimCurrentReward(item)" class="mt-4 mx-auto rounded-lg border-2 border-racing-stars-yellow bg-gray-800 w-40 h-14 p-1 text-racing-stars-yellow hover:bg-gray-700 active:bg-gray-600 font-semibold flex flex-col-1" :class="[!currentReward.value.id ? 'opacity-50' : 'opacity-100', currentReward.value.booster_tag ? 'border-purple-500 text-purple-400' : 'opacity-100']">
                                <p class="my-auto mx-auto">Claim Reward</p> 
                            </button>
                        </tw-modal>
                    </div>

                </div>
            </button>
        </div>
  </div>
</template>

<script> 

import { ChevronUpIcon, FireIcon, CheckIcon, GiftIcon } from '@heroicons/vue/outline'
import RadialProgressBar from 'vue-radial-progress'
import { ref, onMounted, reactive } from 'vue'
import TwModal from '@/Global/Elements/TwModal.vue'

export default {

    components: {
        ChevronUpIcon,
        RadialProgressBar,
        FireIcon,
        CheckIcon,
        GiftIcon,
        TwModal,
    },

    data() {
        return {
            reward_cards : {
                "times_two_multiplier" : {img : 'images/boosts/double-points.png', prize : 'Double Points Multipliers'},
                "times_three_multiplier" : {img : 'images/boosts/triple-points.png', prize : 'Triple Points Multipliers'},
                "times_five_multiplier" : {img : 'images/boosts/quintuple-points.png', prize : 'Times Five Points Multipliers'},
                "times_ten_multiplier" : {img : 'images/boosts/decuple-points.png', prize : 'Times Ten Points Multipliers'},
                "double_runner" : {img : 'images/boosts/double-runner.svg', prize : 'Double Runners'},
                "gems" : {img : 'images/coin-and-tokens/racing-shoe.png', prize : 'Horse Shoes'},
                "tokens" : {img : 'images/coin-and-tokens/token-optimised.svg', prize : 'Stars'},
            },

             milestone_objects : [
                { title: 'Races Won', type: 'counter', description: 'Total amount of races in which a winning runner was picked.', milestone_intervals : 10, tag : 'total_wins'},
                { title: 'Meetings Won', type: 'counter', description: 'Total amount of meetings you have won.', milestone_intervals : 5, tag : 'total_meeting_wins'},
                { title: 'Days Won Streak', type: 'streak', description: 'Amount of consecutive days you won a meeting.', milestone_intervals : 5, tag : 'winning_streak'},
                { title: 'Days Played Streak', type: 'streak', description: 'Amount of days you have played consecutively.', milestone_intervals : 5, tag : 'play_streak'},
            ]
                        
        }
    },

    setup(props) {
        const milestone = ref([0])
        const showReward = ref(false)
        const currentReward = ref([0])
        const rewardCounts = reactive({
            total_wins : 0,
            total_meeting_wins : 0,
            winning_streak : 0,
            play_streak : 0,

        })
        
        const getRewardCounts = () => {
            for (const milestone_tag in rewardCounts) {
                let count = ref(0)
                
                axios.post(route('api.reward.count', {source: milestone_tag}))
                .then(response => {
                    count.value = response.data

                    count = count['_value'];

                    rewardCounts[milestone_tag] = count
                });
            }
        }

        const getMilestone = () => {
            axios.get(route('api.milestone.get'))
                .then(response => {
                    milestone.value = response.data
                    console.log(response.data)
                }
            );
        }
        
        const openReward = (milestone_name) => { 
            currentReward.value = getRewards(milestone_name)
            showReward.value=true
        }

        const getRewards = (tag) => {
            let rewards = ref(0)

            axios.post(route('api.reward.get'), {
                source: tag
            })            
            .then(response => {
                rewards.value = response.data
            });

            return rewards
        }

        const claimCurrentReward = (milestone) => {
            showReward.value = false

            axios.post(route('api.reward.claim'), {
                'id': currentReward.value.value.id,
            });

            getRewardCounts()
        }

        onMounted(() => {
            getRewards()
            getMilestone()
            getRewardCounts()
        })

        return {
            getMilestone,
            milestone,
            openReward,
            showReward,
            currentReward,
            getRewards,
            claimCurrentReward,
            rewardCounts,
        }


    },
}

</script>